module.exports = __webpack_public_path__ + "img/crop3_active.c2851e7a.png";